module.exports = __webpack_public_path__ + "static/media/SubscriptionInActive.90908644.svg";